import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import { SwitchInput } from 'common/react/components/SwitchInput';
import { CheckboxInput } from 'common/react/components/CheckboxInput';
import { getTranslation } from 'common/react/utils/translations';

export const MarketingPreferences = ({ title, subtitle }) => {
    const [privacyAgreed, setPrivacyAgreed] = useState(false);
    const [marketingData, setMarketingData] = useState([
        { name: 'News', status: false },
        { name: 'Trade', status: false },
        { name: 'Draft', status: false },
        { name: 'Fantasy', status: false },
        { name: 'Social Media Highlights', status: false },
        { name: 'Wagering', status: false },
        { name: 'Ticket Offers', status: false },
        { name: 'Podcasts and Vodcasts', status: false },
        { name: 'Shows and Videos', status: false }
    ]);

    const showPrivacyAgreement = useMemo(() => {
        return marketingData.some((setting) => {
            return setting.status === true;
        });
    }, [marketingData]);

    const isBtnDisabled = useMemo(() => {
        if (showPrivacyAgreement && !privacyAgreed) {
            return true;
        }

        return false;
    }, [showPrivacyAgreement, privacyAgreed]);

    return (
        <div className={`modal-marketing-preferences`}>
            {title ? (
                <p className="modal-marketing-preferences__title">{title}</p>
            ) : null}
            {subtitle ? (
                <p className="modal-marketing-preferences__subtitle">
                    {subtitle}
                </p>
            ) : null}
            {}
            {marketingData.map((setting, i) => (
                <SwitchInput
                    id={setting.name}
                    label={setting.name}
                    isChecked={setting.value}
                    onChange={(e) =>
                        handleMarketingChange(
                            i,
                            marketingData,
                            setMarketingData,
                            e
                        )
                    }
                    key={setting.name}
                />
            ))}
            {showPrivacyAgreement ? (
                <div className="modal-marketing-preferences__privacy-agreement">
                    <CheckboxInput
                        id={'privacy-agreement'}
                        label={getTranslation(
                            'settingsModal.PrivacyAgreementNote'
                        )}
                        isChecked={privacyAgreed}
                        onChange={(e) => setPrivacyAgreed(e)}
                    />
                </div>
            ) : null}
            <div className="modal-marketing-preferences__confirmation-container">
                <button
                    disabled={isBtnDisabled}
                    onClick={() =>
                        PULSE.app.common.siteSettings.closeSettingsModal()
                    }
                    className="button-new button-new--primary modal-marketing-preferences-confirmation"
                >
                    {getTranslation('label.done')}
                </button>
            </div>
        </div>
    );
};

const handleMarketingChange = (index, marketingData, setMarketingData, e) => {
    if (typeof e !== 'undefined') {
        const updatedMarketingData = [...marketingData];

        updatedMarketingData[index].status =
            !updatedMarketingData[index].status;
        setMarketingData(updatedMarketingData);
    }
};

MarketingPreferences.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string
};
